import React from 'react';
import DefaultRootSubHeader from './DefaultRootSubHeader';

const DefaultRootHeader = ({
  children,
  title,
  description,
  isChildRoot,
  Prefix,
  Postfix,
  ...rest
}) =>
  isChildRoot ? (
    <DefaultRootSubHeader title={title} description={description}>
      {children}
    </DefaultRootSubHeader>
  ) : (
    <div
      className="default-type-root-header default-type-object-title"
      {...rest}
    >
      {Prefix && <Prefix />}
      <div className="default-type-title-description-wrapper">
        <div className="default-type-title">{title}</div>
        {description && (
          <div className="default-type-description">{description}</div>
        )}
        {children}
      </div>
      {Postfix && <Postfix />}
    </div>
  );

export default DefaultRootHeader;
